(function($){

    function getDataForm(token, form) {
        var formData = new FormData( form.get(0));

        formData.append('action', 'new_ebook_download');
        formData.append('token', token);

        return formData;
    }

    const showMessage = (className, msg, title, form) => {
        const feedback = form.find('.component-feedback');

        feedback.find('.feedback-title').text(title);
        feedback.find('.feedback-description').text(msg);
        feedback.removeClass('success').removeClass('error').addClass(className).fadeIn();
    };

    const showSuccessMsg = (msg, form) => {
        showMessage('success', msg, 'Sucesso!', form);
    }

    const showErrorMsg = (msg, form) => {
        showMessage('error', msg, 'Erro!', form);
    }

    function initNewsletterForm() {
        const forms = $('.form-newsletter')

        forms.each(function(index, formEl){
            const form = $(formEl);

            initFieldMasks(form);

            form.submit(function(e){
                e.preventDefault();
    
                if(!form.valid()){
                    return false;
                }

                const gaCategory = jQuery('input[name=download_type]').val();
                window.ga('send', 'event', gaCategory, 'registro');
    
                grecaptcha.ready(function() {
                    grecaptcha.execute('6LeOUvIUAAAAAIfWVcUvMOsiKK2GY8ko7IHW4W0Q', {action: 'submit'}).then(function(token) {
                        sendData(token, form);
                    });
                });
            });
    
            form.validate({
                rules: {
                    email: {
                        required: true,
                        email: true,
                    },
                },
                errorPlacement: function(error, element) {
                    if (element.attr('name') === 'accept') {
                        error.insertAfter(form.find('#accept_term_label'));
                    } else {
                        error.insertAfter(element);
                    }
                },
            });
        })
    }

    function initFieldMasks(form) {
        const phone = form.find('[name=phone]');

        if(!phone.length){ return; }

          const SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
          };
          const spOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
              }
          };

          phone.mask(SPMaskBehavior, spOptions);
    }

    function sendData(token, form) {
        let btnText = $('.btn', form).text();
        $.ajax({
            type: 'post',
            url: '/wp/wp-admin/admin-ajax.php',
            data: getDataForm(token, form),
            dataType: 'json',
            mimeType: 'multipart/form-data',
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: () => {
                $('.btn', form).prop('disabled', true).text('Enviando...');
            },
            success: (result) => {
                if(result.status === '1') {
                    form.get(0).reset();
                    showSuccessMsg(result.msg, form);
                } else {
                    showErrorMsg(result.error, form);
                }
                loadDownload(result, form);
                saveDownloadSucces(result);
            },
            error: console.error,
            complete: () => {
                $('.btn', form).prop('disabled', false).text(btnText);
            },
        });
    }

    function getDownloadCache() {
        let downloadCache = {};
        if(localStorage.downloadCache) {
            downloadCache = JSON.parse(localStorage.downloadCache);
        }
        return downloadCache;
    }

    function updatedDownloadCache(cache) {
        localStorage.downloadCache = JSON.stringify(cache);
    }

    function saveDownloadSucces(result) {
        const downloadCache = getDownloadCache();
        downloadCache[result.post_id] = result;
        updatedDownloadCache(downloadCache);
    }

    function getDownloadCacheByPostId(postId) {
        const downloadCache = getDownloadCache();
        if(downloadCache[postId]) {
            return downloadCache[postId];
        }
        return false;
    }

    function loadDownload(result, form) {
        form.find('.fields-container').slideUp(function(){
            let downloadedPlayer = ""

            if(result.type === 'ebook') {
                return;
            }

            const downloadCard = $('.component-download-post');

            if(result.type === 'audio') {
                downloadedPlayer = renderAudioHtml(result.watchUrl);
                downloadCard.find('.download-display').html(downloadedPlayer);
            } else if(result.type === 'video') {
                downloadedPlayer = renderVideoHtml(result.watchUrl);
            }

            downloadCard.addClass('playing');
            downloadCard.find('.image-holder').removeClass('d-flex').addClass('d-none');
            downloadCard.find('.description-holder').removeClass('col-md-5').addClass('col-12');
        });
    }

    function renderAudioHtml(audioUrl) {
        return $(`<audio autoplay="autoplay" controls="controls">
                        <source src="${audioUrl}" type="audio/mp3" />
                        Seu navegador não suporta HTML5
        </audio>`);
    }

    window.YouTubeGetID = function(url){
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);  // eslint-disable-line
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];  // eslint-disable-line
     }

    function renderVideoHtml(videoUrl) {
        if(videoUrl) {
            // Load the IFrame Player API code asynchronously.
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/player_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function() {

                const videoId = window.YouTubeGetID(videoUrl);

                new YT.Player('download-display', {  // eslint-disable-line
                    height: '360',
                    width: '640',
                    videoId: videoId,
                    events: {
                      'onStateChange': window.onPlayerStateChange
                    },
                });
            }

            window.firstPlay = false;
            window.firstEnd = false;
            window.onPlayerStateChange = function(event) {
                if (event.data === YT.PlayerState.PLAYING && !window.firstPlay) {
                    window.ga('send', 'event', 'video', 'tocar');
                    window.firstPlay = true;
                }

                if (event.data === YT.PlayerState.ENDED && !window.firstEnd) {
                    window.ga('send', 'event', 'video', 'final');
                    window.firstEnd = true;
                }
            }
        }
    }
    
    $('document').ready(function(){
        initNewsletterForm();

        const postId = $('.form-newsletter').data('id');
        const form = $('.form-newsletter');

        const cached = getDownloadCacheByPostId(postId);

        if(cached && cached.type !== 'ebook') {
            loadDownload(cached, form);
        }
    });
})(jQuery)

